import {
  INPUT_VALUE_COVER_TYPE_HARD,
  INPUT_VALUE_COVER_TYPE_SOFT,
} from '@shared/common/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { getPriceData } from '@shared/jp/data/products';
import {
  BOOK_PRICE_GIFT_TM,
  BOOK_PRICE_GIFT_TM_HARD_COVER,
} from '@shared/jp/product';
import GiftShared from '@shared/jp/vendors/tokyoMetro/data/products/books/GiftShared';
import { getCoverHard, getCoverSoft } from './_utils';

const prices = {
  [INPUT_VALUE_COVER_TYPE_SOFT]: getPriceData(BOOK_PRICE_GIFT_TM),
  [INPUT_VALUE_COVER_TYPE_HARD]: getPriceData(BOOK_PRICE_GIFT_TM_HARD_COVER),
} as const;

const coverSoft = getCoverSoft({
  price: prices[INPUT_VALUE_COVER_TYPE_SOFT],
  carousel: [
    'assets/images/covers/bk2/bk2-SC01.jpg',
    'assets/images/covers/bk2/bk2-SC02.jpg',
    'assets/images/covers/bk2/bk2-SC03.jpg',
  ],
});
const coverHard = getCoverHard({
  price: prices[INPUT_VALUE_COVER_TYPE_HARD],
  carousel: [
    'assets/images/covers/bk2/bk2-HC01.jpg',
    'assets/images/covers/bk2/bk2-HC02.jpg',
    'assets/images/covers/bk2/bk2-HC03.jpg',
  ],
});

const Gift: IBookPreview = {
  ...GiftShared,
  caption: '相手の方が絵本を選べる',
  summary:
    '絵本の種類は、相手の方がBÜKIの絵本リストから選びます。どんな絵本がいいかわからない、すでに持ってる絵本があるかも、そんな時はこちらをご利用ください。',
  prices: [
    [INPUT_VALUE_COVER_TYPE_SOFT, prices[INPUT_VALUE_COVER_TYPE_SOFT]],
    [INPUT_VALUE_COVER_TYPE_HARD, prices[INPUT_VALUE_COVER_TYPE_HARD]],
  ],
  photos: ['assets/images/bk2-carousel01-JP.jpg'],
  menuPhoto: 'assets/images/bkANY-sample-JP.jpg',
  previewPhoto: 'assets/images/products/product-bk2.jpg',
  properties: {
    purpose: [],
    age: {
      start: 0,
      end: 9999,
    },
  },
  notice: {
    caption: 'BEST BOOK',
    description: '100% mega book',
    points: [
      {
        imgSrc: 'assets/images/birthday-notice-point-1.png',
        caption: '１～１０歳、どなたでも',
      },
      // {
      //   imgSrc: 'assets/images/birthday-notice-point-2.png',
      //   caption: 'TODOOOOO',
      // },
    ],
  },
  points: [
    {
      caption: 'TODODO',
      description:
        '・主人公の名前をいれる<br>・主人公のイラストを選択する<br>・誕生日前日が絵本のストーリーになる<br>・絵本に登場するキャラクターを選択する<br>・メッセージを書き込む<br>・写真をいれる<br>・ストーリーの季節設定を変更する',
    },
    {
      caption: 'TODODODO',
      description:
        'もう寝る時間なのに、なんだか騒がしい人たちがいます。「明日はこの街に住むみんな大好きなあの子の誕生日だ！」と、しっちゃかめっちゃかにパーティの準備をします。さぁ、明日は誰の誕生日？',
    },
    {
      caption: 'TODODODODO',
      description:
        '全ての絵本は１冊ずつ、ご注文を受けてからオーダーメイドで印刷・製本されます。マットで高級感のある、環境に配慮した用紙を使用しています。<br><br><b>・全28 ページ<br>・21cm x 21cm（本文部分）の正方形<br>・日本国内で製造</b>',
    },
  ],
  inputs: [],
  // banner: {},
  description: [],
  review: {
    text: ['TODOTOTODO'],
  },
  reviews: [],
  options: {
    [INPUT_VALUE_COVER_TYPE_HARD]: coverHard,
    [INPUT_VALUE_COVER_TYPE_SOFT]: coverSoft,
  },
  option: INPUT_VALUE_COVER_TYPE_SOFT,
  popularity: 9999,
  createdAt: new Date('2025-01-22'),
};

export default Gift;
